/***
 * @file portal形式的弹窗。可以自定义样式，比如任意位置的toast，全局新手指导的浮动标志等
 * @example
    <PortalDialog show={this.state.show}>
        <p style={{'color': this.state.show? 'red': '#000'}}>This thing was portaled!</p>
    </PortalDialog>

*/

import React, { Component } from 'react';
import { querySelector } from '@umu/umu-dom';
import { Dialog, DialogBody, IDialogProps } from '../dialog/dialog';
import Portal from '../portal';

export interface IPortalDialog extends IDialogProps {
    show: boolean; // 是否显示弹窗
    hasMask?: boolean; // 是否显示遮罩层
    className?: string; // 自定义类名
    canClose?: boolean; // 是否显示右上角的关闭按钮
    close?: () => void; // 点击关闭按钮时触发
}

export default class PortalDialog extends Component<IPortalDialog> {
    public static defaultProps = {
        show: false,
        hasMask: true,
        className: '',
        canClose: false,
    };

    constructor(props: IPortalDialog) {
        super(props);
    }

    public render() {
        const { show, hasMask, className, canClose, close, width, canAbsolute, closeOnMaskClick } = this.props;

        return (
            <Portal node={querySelector('.doc')}>
                <Dialog
                    show={show}
                    hasMask={hasMask}
                    canAbsolute={canAbsolute}
                    className={`modal-dialog ${className}`}
                    canClose={canClose}
                    close={close}
                    width={width}
                    closeOnMaskClick={closeOnMaskClick}
                >
                    <DialogBody>{this.props.children}</DialogBody>
                </Dialog>
            </Portal>
        );
    }
}
